export default {
  namespaced: true,
  state: () => {
    return {
      selectedJackpotId: "all",
      selectedTheme: "all",
      filteredMachineList: [],
      isFilteredFavorite : false,
    };
  },
  getters: {
    getSelectedJackpotId: (state) => {
      return state.selectedJackpotId;
    },
    getSelectedTheme: (state) => {
      return state.selectedTheme;
    },
    getFilteredMachineList: (state) => {
      return state.filteredMachineList;
    },
    getIsFilteredFavorite: (state) => {
      return state.isFilteredFavorite;
    },
  },
  mutations: {
    setSelectedJackpotId(state, jackpotId) {
      state.selectedJackpotId = jackpotId;
    },
    setSelectedTheme(state, themeId) {
      state.selectedTheme = themeId;
    },
    setFilteredMachineList(state, filteredList) {
      state.filteredMachineList = filteredList;
    },
    setIsFilteredFavorite(state, isFiltered) {
      state.isFilteredFavorite = isFiltered;
    },
  },
};